import { pulseAxiosInstance } from "@pulse/api/axiosInstance";

export type CommentType = { id: number; answerComment: string; answerId: number };

export type Answer = {
    comment: CommentType | null;
    id: number;
    surveyQuestionId: number;
    answerValue: string | number | number[];
};

export const getAnswersBySurveyId = async ({ surveyId }: { surveyId: number }): Promise<Answer[]> =>
    (await pulseAxiosInstance.get(`answers/survey/${surveyId}`)).data;
